import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const PlaceholderCard = styled.div`
  background: #f8f9fa;
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  border: 2px dashed #dee2e6;
`;

const QualityVerification = () => {
  return (
    <Container>
      <PlaceholderCard>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔍</div>
        <h3 style={{ margin: '0 0 12px 0', color: '#495057' }}>Quality Verification</h3>
        <p style={{ color: '#6c757d', margin: 0 }}>
          Quality inspection and verification workflows for deposited commodities will be displayed here.
        </p>
      </PlaceholderCard>
    </Container>
  );
};

export default QualityVerification; 